/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Treatment/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LocationChoice from './LocationChoice/index'
import Name from './Name/index'
import React from 'react'
import Status from './Status/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Treatment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/Treatments/Content/Treatment"
  
}) {
  let isMedia = useIsMedia()
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Treatment.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-2i9IjI': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--fd-3-2i9IjI': isMedia.mobile ? "column" : "row",'--ai-2-2i9IjI': isMedia.mobile ? "flex-start" : "center"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Treatment.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-4-2i9IjI': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Status
  viewPath={`${viewPath}/Status`}
/>
</div>
<div
  data-testid="Treatment.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<LocationChoice
  viewPath={`${viewPath}/LocationChoice`}
/>
</div>
</div>
{children}
</React.Fragment>)
}